var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.detailComponent)?_c(_vm.detailComponent,_vm._b({tag:"component",attrs:{"part":_vm.part}},'component',_vm.detailProps,false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }